import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface SidebarItem {
  to: string;
  labelKey: string;
}

const items: SidebarItem[] = [
  { to: '/admin/usage-report', labelKey: 'admin:sidebar.usageReport' },
  { to: '/admin/roi-insights', labelKey: 'admin:sidebar.roiInsights' },
  { to: '/admin/auto-shutdown-settings', labelKey: 'admin:sidebar.autoShutdownSettings' },
  { to: '/admin/memory-settings', labelKey: 'admin:sidebar.memorySettings' },
  { to: '/admin/audit-log', labelKey: 'admin:sidebar.auditLog' },
];

const AdminSidebar: React.FC = () => {
  const { t } = useTranslation(['admin']);
  return (
    <nav className="admin-sidebar">
      <ul>
        {items.map(item => (
          <li key={item.to}>
            <NavLink to={item.to} activeClassName="active">
              {t(item.labelKey)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default AdminSidebar;
